import React from 'react';
import { TiLocation } from 'react-icons/ti';
import { IoIosPulse } from 'react-icons/io';

const ConditionCard = ({ location, weather, plant }) => {
  return (
    <div className="w-full md:w-85 lg:w-90 bg-cf-300 rounded px-2 md:px-4 py-2 text-white">
      <div className="flex flex-wrap justify-around items-center">
        <div className="flex flex-col items-center justify-center p-1">
          <TiLocation size="35" color="#f7fafc" />
          <p className="text-base block -mt-1">{location.name}</p>
        </div>
        <div className="bg-gray-100 text-gray-800 flex flex-col items-center justify-center p-1 ml-4">
          <IoIosPulse size="35" color="#3c9130" />
          <p className="text-base block -mt-1">{plant && plant.health}</p>
        </div>
        <div className="ml-2">
          <img
            src={`https://openweathermap.org/img/w/${weather.icon}.png`}
            alt={weather.description}
          />
          <p className="text-base block -mt-2 capitalize">{weather.description}</p>
        </div>
      </div>
    </div>
  );
};

export default ConditionCard;
